// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__1mzaw","item":"List_item__1tx6u","icon":"List_icon__1sRbJ","group":"List_group__3K365","title":"List_title__3ofkP"};